import { render, staticRenderFns } from "./senarai.vue?vue&type=template&id=ae78467c&"
import script from "./senarai.vue?vue&type=script&lang=js&"
export * from "./senarai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports